<div
    class="flex flex-wrap gap-2 items-center rounded-[16px] border-border border-[1px] p-5 mt-5 w-full max-w-ultrawide min-w-[300px] mobile:flex-col">
    <div class="w-[160px] h-[160px] mobile:w-[100px] mobile:h-[100px]">
        <app-custom-avatar [initials]="userInitials" [imageUrl]="getProfileImage"
            textSize="text-[52px] mobile:text-[40px]"></app-custom-avatar>
    </div>
    <div class="ml-5 flex flex-col mobile:mt-5 mobile:items-center">
        <p class="font-bold text-2xl">{{name}}</p>
        <p class="text-neutral-1200">{{role}}</p>
    </div>
    <div class="flex-[1]"></div>
    <div class="flex flex-wrap gap-2 items-center mobile:flex-col mobile:mt-5">
        <div class="w-[150px] h-[50px]">
            <app-custom-button buttonText="{{ 'settings.button.share' | transloco }}" [isDisabled]="false"
                backgroundColor="bg-white" textColor="text-neutral-1200" borderColor="border-border"
                hoverBackgroundColor="hover:bg-neutral-1200" hoverBorderColor="hover:border-neutral"
                trailingIcon="assets/icons/settings/share.svg" (click)="onShareClick()">
            </app-custom-button>
        </div>

        <div class="w-[150px] h-[50px]">
            @if (!editing) {
            <app-custom-button buttonText="{{ 'settings.button.edit' | transloco }}" [isDisabled]="false"
                backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
                hoverBackgroundColor="hover:bg-primary-1200" trailingIcon="assets/icons/settings/edit.svg"
                (click)="onEditClick()">
            </app-custom-button>
            }
            @else {
            <app-custom-button buttonText="{{ 'shared.save' | transloco }}" [isDisabled]="false"
                backgroundColor="bg-secondary" textColor="text-white" borderColor="border:bg-secondary"
                hoverBackgroundColor="hover:bg-secondary-1200" hoverBorderColor="hover:border-secondary-1200"
                trailingIcon="assets/icons/upload-white.svg" (click)="onEditClick()">
            </app-custom-button>
            }
        </div>
    </div>
</div>